import AuthService from '../../services/auth.service';
import Vue from 'vue';
import i18n from "@/i18n";

const user = JSON.parse(localStorage.getItem('user'));
const accessToken = JSON.parse(localStorage.getItem('accessToken'));
const initialState = user
    ? { status: { loggedIn: true }, user, accessToken: accessToken }
    : { status: { loggedIn: false }, user: null, accessToken: '' };

export const state = initialState;

export const getters = {
    loggedIn(state) {
        return state.status.loggedIn;
    },
    user(state) {
        return state.user;
    }
};

export const actions = {
    loginToken({ commit }, info) {
        return AuthService.loginToken(info.dbid, info.token).then(
            response => {
                commit('loginSuccess', response);
                return Promise.resolve(response);
            },
            error => {
                return Promise.reject(error);
            }
        );
    },
    loginOffline({ commit }, info) {
        return AuthService.loginOffline(info.email, info.password).then(
            response => {
                commit('loginSuccess', response);
                return Promise.resolve(response);
            },
            error => {
                commit('loginFailure', error);
                return Promise.reject(error);
            }
        );
    },
    refreshClientInfo({ commit }, force = false) {
        return new Promise((resolve, reject) => {
            AuthService.refreshClientInfo(force).then(
                response => {
                    commit('refreshClientInfo', response);
                    resolve(response);
                },
                error => {
                    if (error.data.status === 401)
                        commit('forbidden');
                    reject(error)
                }
            )
        });
    },
    logout({ commit }) {
        commit('logout');
        AuthService.logout();
    },
    forbidden({ commit }, message) {
        AuthService.logout();
        commit('forbidden', message);
    },
};

export const mutations = {
    loginSuccess(state, response) {
        state.status.loggedIn = true;
        state.user = response.user;
        state.accessToken = response.accessToken;
    },
    loginFailure(state, error) {
        state.status.loggedIn = false;
        state.user = null;
        state.accessToken = '';
        
        if (error.response) {
            return error;
        }
    },
    refreshClientInfo(state, response) {
        state.user = response;
    },
    logout(state) {
        state.status.loggedIn = false;
        state.user = null;
        state.accessToken = '';
    },
    forbidden(state, message = null) {
        state.status.loggedIn = false;
        state.user = null;
        state.accessToken = '';
        
        Vue.swal.fire({
            title: i18n.t('store.forbidden.title'),
            text: i18n.t('store.forbidden.desc') + (message ? i18n.t('store.forbidden.message') + message : ''),
            icon: 'error',
            timer: 2000,
            showConfirmButton: false,
        });
    }
};